import { Button } from "./ui/button";
import { ArrowRight, Building2, Award, ShieldCheck } from "lucide-react";
import heroImage from "../assets/hero-luxury-building.jpg";


const WelcomeSection = () => {
  return (
    <section
      className="relative py-24 overflow-hidden bg-gradient-to-b from-white to-muted/20"
      id="about"
    >
      {/* ----- Background Image with Overlay ----- */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Skyline Properties - Premium real estate in Solapur"
          className="w-full h-full object-cover opacity-20 scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-transparent" />
      </div>

      {/* ----- Main Container ----- */}
      <div className="relative container mx-auto px-6 z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* ---------- LEFT CONTENT ---------- */}
          <div className="space-y-10 animate-fade-up">
            <div className="space-y-5">
              <h2 className="font-display-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight text-primary">
                Welcome to
                <span className="block text-luxury drop-shadow-sm">
                  Skyline Properties
                </span>
              </h2>

              <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-xl">
                For over a decade, Skyline Properties has been Solapur’s most trusted
                name in premium real estate. We create exceptional living spaces that
                combine <span className="font-semibold text-primary">modern
                architecture</span> with <span className="font-semibold text-primary">
                timeless values</span>.
              </p>

              <p className="text-base sm:text-lg text-muted-foreground max-w-lg leading-relaxed">
                Our commitment to <strong>quality construction</strong>, timely delivery,
                and outstanding customer satisfaction has made us the preferred choice
                for discerning homebuyers and savvy investors in Solapur and beyond.
              </p>
            </div>

            {/* ----- Stats Cards ----- */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-5">
              <div className="glass-card p-6 rounded-xl shadow-md text-center hover:scale-105 transition-transform">
                <Award className="w-8 h-8 mx-auto text-luxury mb-3" />
                <div className="text-2xl font-display-bold text-primary">15+ Yrs</div>
                <p className="text-sm text-muted-foreground">Experience</p>
              </div>

              <div className="glass-card p-6 rounded-xl shadow-md text-center hover:scale-105 transition-transform">
                <ShieldCheck className="w-8 h-8 mx-auto text-green-500 mb-3" />
                <div className="text-2xl font-display-bold text-primary">100%</div>
                <p className="text-sm text-muted-foreground">Trust & Safety</p>
              </div>

              <div className="glass-card p-6 rounded-xl shadow-md text-center hover:scale-105 transition-transform hidden sm:block">
                <Building2 className="w-8 h-8 mx-auto text-indigo-500 mb-3" />
                <div className="text-2xl font-display-bold text-primary">500+</div>
                <p className="text-sm text-muted-foreground">Homes Delivered</p>
              </div>
            </div>

            {/* ----- Call-to-Action Button ----- */}
            {/* <div>
              <Button
                size="lg"
                className="bg-gradient-to-r from-luxury to-primary hover:from-primary hover:to-luxury text-white shadow-xl rounded-full px-8 py-6 text-lg font-medium group transition-all duration-300"
              >
                Learn More About Us
                <ArrowRight className="ml-2 h-6 w-6 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div> */}
          </div>

          {/* ---------- RIGHT IMAGE CARD ---------- */}
          <div className="relative animate-fade-up" style={{ animationDelay: "0.3s" }}>
            <div className="rounded-3xl overflow-hidden shadow-2xl relative group">
              <img
                src={heroImage}
                alt="Skyline luxury buildings"
                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/50 via-primary/20 to-transparent" />

              {/* Info Box at Bottom */}
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/20 backdrop-blur-xl rounded-2xl p-5 shadow-lg border border-white/20">
                  <h3 className="font-display-bold text-xl text-white drop-shadow-md">
                    Your Dream Home Awaits
                  </h3>
                  <p className="text-sm text-white/90">
                    Discover the perfect blend of luxury, comfort, and lasting value
                    with Skyline Properties.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
